import React, { useState, Fragment, useEffect, useLayoutEffect } from "react";
import styles from "./ScheduledCciApps.module.css";
import { Card, Col, Input, Row, Select, Spin, Table, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { fetchJsData } from "../../../../api";
import { crawl } from "../../../../api/util";
// import { Menus, ColoredLine } from "../../../AppLayout/AppLayout";
import {
  newApps,
  chngCclApps,
  newDomain,
  catChngApps,
  nameChngApps,
  breachedApps,
  // getJs,
  cardCss,
  tabPageCss,
} from "./columns";
const { Option } = Select;
const { Text } = Typography;

const ScheduledCciApps = (props) => {
  const [renderer, updateRender] = useState("tab1");
  const [load, setLoad] = useState(true);
  const [data, setData] = useState([]);
  const key =
    props.usrSch == "Scheduled" ? 1 : props.usrSch == "Deployed" ? 0 : 2;

  useEffect(() => {
    if (props.loader === false) {
      fetchData();
    }
    console.log("props", props.loader);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.loader]);

  const fetchData = async () => {
    setLoad(true);
    const data = await fetchJsData({
      type: "fetch",
      qry: "fetWkCciChanges",
    });
    console.log("data in pro mod");
    console.log(data["data"].filter((x) => x.request_type === "breached_apps"));
    setData({
      newApps: data["data"]
        .filter((x) => x.request_type === "new_apps")
        .map((x) => {
          return {
            id: x.id,
            new_app_name: x.new_app_name,
            current_category: x.current_category,
            current_ccl: x.current_ccl,
            scheduled: x.scheduled,
            scheduled_date: x.scheduled_date,
          };
        }),
      newDomains: data["data"]
        .filter((x) => x.request_type === "new_domains")
        .map((x) => {
          return {
            id: x.id,
            new_app_name: x.new_app_name,
            current_category: x.current_category,
            old_domain: x.old_domain,
            new_domain: x.new_domain,
            scheduled: x.scheduled,
            scheduled_date: x.scheduled_date,
          };
        }),
      chngCclApps: data["data"]
        .filter((x) => x.request_type === "ccl_changed_apps")
        .map((x) => {
          return {
            id: x.id,
            new_app_name: x.new_app_name,
            current_category: x.current_category,
            old_ccl: x.old_ccl,
            current_ccl: x.current_ccl,
            scheduled: x.scheduled,
            scheduled_date: x.scheduled_date,
          };
        }),
      catChngApps: data["data"]
        .filter((x) => x.request_type === "category_changed_apps")
        .map((x) => {
          return {
            id: x.id,
            new_app_name: x.new_app_name,
            old_category: x.old_category,
            current_category: x.current_category,
            scheduled: x.scheduled,
            scheduled_date: x.scheduled_date,
          };
        }),
      appNameChng: data["data"]
        .filter((x) => x.request_type === "name_changed_apps")
        .map((x) => {
          return {
            id: x.id,
            old_app_name: x.old_app_name,
            new_app_name: x.new_app_name,
            scheduled: x.scheduled,
            scheduled_date: x.scheduled_date,
          };
        }),
      breachedApps: data["data"]
        .filter((x) => x.request_type === "breached_apps")
        .map((x) => {
          return {
            id: x.id,
            new_app_name: x.new_app_name,
            current_category: x.current_category,
            scheduled: x.scheduled,
            breached_date: x.breached_date,
            scheduled_date: x.scheduled_date,
          };
        }),
    });
    setLoad(false);
  };

  const onTabChng = (key) => {
    updateRender(key);
    props.setSubmit(!props.submit);
  };

  const contentList = {
    tab1: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={newApps}
        usrSel="new_apps"
        setLiveMenu={props.setLiveMenu}
        data={data["newApps"]}
        usrSch={key}
        key={"1"}
      />
    ),
    tab2: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={newDomain}
        usrSel="new_domains"
        setLiveMenu={props.setLiveMenu}
        data={data["newDomains"]}
        usrSch={key}
        key={"2"}
      />
    ),
    tab3: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={chngCclApps}
        usrSel="changed_ccl_apps"
        data={data["chngCclApps"]}
        setLiveMenu={props.setLiveMenu}
        usrSch={key}
        key={"3"}
      />
    ),
    tab4: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={catChngApps}
        usrSel="category_changed_apps"
        data={data["catChngApps"]}
        setLiveMenu={props.setLiveMenu}
        usrSch={key}
        key={"4"}
      />
    ),
    tab5: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={nameChngApps}
        usrSel="name_changed_apps"
        data={data["appNameChng"]}
        setLiveMenu={props.setLiveMenu}
        usrSch={key}
        key={"5"}
      />
    ),
    tab6: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={breachedApps}
        usrSel="breached_apps"
        data={data["breachedApps"]}
        setLiveMenu={props.setLiveMenu}
        usrSch={key}
        key={"6"}
      />
    ),
  };

  return (
    <div>
      {/* Card */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        {/* <Col className="gutter-row" span={1}></Col> */}
        <Col className="gutter-row" span={23}>
          <Card
            style={{ width: "100%", minHeight: "80vh" }}
            bodyStyle={cardCss}
            tabList={tabList}
            onTabChange={onTabChng}
            // loading={load}
          >
            {!load ? (
              contentList[renderer]
            ) : (
              <div className={styles.spinner}>
                <Spin size="small" />
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const FetchTabSearch = (props) => {
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);
  const schData =
    props.usrSch !== 2
      ? props.data.filter((x) => x.scheduled === props.usrSch)
      : props.data;

  const schColIndicator =
    props.usrSch === 1
      ? "Scheduled Date"
      : props.usrSch === 0
      ? "Deployed Date"
      : "Scheduled / Deployed Date";

  useEffect(() => {
    // console.log("usr -", props.usrRel, props.rel);
    setLoading(true);

    props.setLiveMenu({ release: false, topMenu: "S", botMenu: "1" });
    setOrigData(schData);
    setFilteredData(schData);
    const searchInd = schData.map((user) => {
      const allValues = crawl(user);
      return { allValues: allValues.toString() };
    });
    setSearchIndex(searchInd);
    console.log("filter- ", filteredData, schData);
    setLoading(false);
  }, [props.usrSch]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.usrSch]);

  return (
    <>
      <div>
        <Row gutter={16}>
          <Col span={24}>
            <Card
              title={
                loading ? (
                  <div>
                    <Spin size="small" />
                  </div>
                ) : (
                  <Row>
                    <Col spane={6}>
                      <Text>
                        {props.usrSch === 1
                          ? "Scheduled"
                          : props.usrSch === 0
                          ? "Deployed"
                          : "All"}
                      </Text>
                    </Col>
                  </Row>
                )
              }
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
              extra={
                <Row>
                  <Col span={21}>
                    <Input
                      onChange={(e) => setSearchVal(e.target.value)}
                      prefix={
                        <SearchOutlined className="site-form-item-icon" />
                      }
                      placeholder="Crawl Search"
                      allowClear
                    />
                  </Col>
                  <Col span={1}></Col>
                </Row>
              }
            >
              <Fragment>
                <Table
                  rowKey="id"
                  size="small"
                  bordered
                  scroll={{ x: 550, y: 900 }}
                  style={{ margin: "2px" }}
                  dataSource={filteredData}
                  columns={props.col(filteredData.length, schColIndicator)}
                  loading={false}
                  pagination={{
                    pageSizeOptions: ["10", "30", "60", "100", "1000"],
                    defaultPageSize: ["50"],
                    showSizeChanger: true,
                    style: tabPageCss,
                  }}
                />
              </Fragment>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

const tabList = [
  {
    key: "tab1",
    tab: "New Apps",
  },
  {
    key: "tab2",
    tab: "New Domains",
  },
  {
    key: "tab3",
    tab: "CCL Changed Apps",
  },
  {
    key: "tab4",
    tab: "Category Changed Apps",
  },
  {
    key: "tab5",
    tab: "Name Changed Apps",
  },
  {
    key: "tab6",
    tab: "Breached Apps",
  },
];

export default ScheduledCciApps;
